import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ReferralRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');

    if (code) {
      navigate(`/register?source=ib_referral&referralCode=${code}`, {
        replace: true,
      });
    } else {
      navigate('/register', { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to registration...</p>
      </div>
    </div>
  );
};

export default ReferralRedirect;
